'use strict';

wbApp.controller('FranchisesAttendanceSummaryCtrl', ['$scope', 'franchiseSvc',
function ($scope, franchiseSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();

    $scope.onDateRangeChanged = function () {
        $scope.attendanceSummary = franchiseSvc.getAttendanceSummaryAsync($scope.fromDate, $scope.toDate);
    }

    $scope.attendanceSummary = franchiseSvc.getAttendanceSummaryAsync($scope.fromDate, $scope.toDate);

    $scope.gridOptions = {
        sortInfo: { fields: ['tenantName'], directions: ['dsc'] },
        noCommandColumn: true,
        columnDefs: [
            { field: 'franchiseSubjectName', displayName: "TXT_LBL_SUBJECT", sort: 'locale' },
            { field: 'tenantName', displayName: "TXT_LBL_PARTNER", sort: 'locale', width: "200px" },
            { field: 'employeeFullName', displayName: "TXT_LBL_EMPLOYEE", sort: 'locale', width: "200px" },
            { field: 'noOFCredits', displayName: "TXT_LBL_NO_OF_CREDITS", width: "120px", align: 'right' }
        ]
    };

    //$scope.franchises = franchiseSvc.getAllAsync(true);
}]);